export default "__VITE_ASSET__BIO5D2i8__"